var json = $('#group_data_handles').val();
var split_array = json.split(',');

//get product data from metafields
async function get_product_data(handle) {

    var product_data;

    await jQuery.getJSON(`/products/${handle}.js`, function (product) {
        // console.log(product);

        product_data = product;

    });

    return product_data;

}


//accordion initialize
function accordion_init() {


    $('.btnlooksp1').click(function () {
        $('.product-looks-wrapper').show();
        var positionn = $('.header__inline-menu').offset().top - 350;

        $('html, body').animate({
            scrollTop: positionn
        }, 1000);
    })
    $('.looks-close').click(function () {
        $('.product-looks-wrapper').hide();
    })

    let buttons = $('.product-form__buttons');
    $('.addtocart-looks').append(buttons);

    $('.looks-pannel-group .product-item').each(function (index, item) {
        $(item).find('.panel-heading').click(function () {
            $(this).toggleClass('minus');
            let panelBody = $(this).parent('.product-item').find('.pnael-body');
            panelBody.slideToggle('slow');

            $('.looks-pannel-group .product-item').not($(item)).find('.pnael-body').slideUp('slow');
            $('.looks-pannel-group .product-item').not($(item)).find('.panel-heading').removeClass('minus');
        });
    });



}

//update total price
function total_price() {


    var total_price = 0;

    $('.panel.panel-default.product-item').find('input[type="checkbox"]:checked').each(function (index, value) {

        var selected_item = $(value).parents('.panel.panel-default.product-item');

        // console.log(selected_item.find('input[type="radio"]:checked').attr('variant-id'));

        var var_price = selected_item.find('input[type="radio"]:checked').attr('variant-price');

        total_price += parseFloat(var_price);


    });

    total_price = total_price.toFixed(2);

    // console.log(total_price);

    $('.price-looks').text(total_price + '€');

}


//add to cart data collect
function add_to_cart_group() {

    var items = [];

    $('.panel.panel-default.product-item').find('input[type="checkbox"]:checked').each(function (index, value) {

        var selected_item = $(value).parents('.panel.panel-default.product-item');

        var variant_id = selected_item.find('input[type="radio"]:checked').attr('variant-id');

        // console.log(variant_id);

        var obj = {};

        obj['id'] = variant_id;
        obj['quantity'] = 1;

        // console.log(obj);

        items.push(obj);

    });

    // console.log(items);

    add_to_cart_actuate(items);

}

//add to cart function
function add_to_cart_actuate(data) {

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            items: data
        },
        dataType: 'json',
        success: function () {

            window.location.replace('/cart');

        }
    });


}


//initialize bundle
function bundle_init() {


    $.each(split_array, async function (index, value) {

        var value = value.trim();

        var product = await get_product_data(value);

        console.log(product);

        var price = product.price / 100;

        price = price.toFixed(2);

        var variants = product.variants;

        var variant_html = '';

        $.each(variants, function (index, value) {

            // console.log(value);

            var checked = '';

            if (index == 0) {
                checked = 'checked';
            }

            variant_html += `<div class="variant_item" variant-id="${value.id}" variant-price='${value.price / 100}'><label>${value.title}</label><input type='radio' ${checked} class="variant_radio" name="${product.id}" variant-id="${value.id}" variant-price='${value.price / 100}'></div>`;

        });

        $('.looks-pannel-group').append(`<div class="panel panel-default product-item">
                <div class="panel-heading"><h4>${product.title}</h4></div>
                <div class="pnael-body">
                <div class="looks-pro-wrapper">
                   <div class="figure">
                      <img src="${product.featured_image}" alt="product-image" height="100" width="100"/>
                   </div>
                   
                   <div class='variants'>
                   ${variant_html}
                   </div>
                  
                  <div class="price-varinet">
                    <span class="price">€${price}</span>
                  </div
                   </div>
                  <div class="looks-remove">
                    <span><input type="checkbox" onchange="total_price();" checked>QUITAR DEL LOOK</span>
                  </div>`);

 

        $('.container-product').append(`<div class="product-card" >
                  <a href="/products/${product.handle}" tabindex="0">
                  <div class="img">
                    <img src="${product.featured_image}" alt="${product.title}">
                  </div>
  
                 <div class="image-info"> 
                    <div class="img-content">
                      <h3>${product.title}</h3>
                      
                      <div class="price">
                  <span class="cmp-price" style="text-decoration: line-through;">  </span>
                      <span class="regular-price">   €${price} EUR </span>
                      </div>
                    </div>
                 </div>
                  
                </a>
           
              </div>`);

    });

    setTimeout(function () {
        accordion_init();

        //track variant change price
        $('.variant_radio').on('change', function () {

            var price = $(this).parents('.variant_item').attr('variant-price');

            price = parseFloat(price);

            price = price.toFixed(2);

            console.log(price);

            $(this).parents('.variants').next('.price-varinet').find('.price').text('€' + price);

            total_price();

        });

        //get total price on load
        total_price();

    }, 750);



}


bundle_init();

